import { useCallback } from 'react';
import { track, TrackProps } from '../services/tracking';

/** Stable `track(name, props)` for components. Fire-and-forget; never throws. */
export function useTrack(): (name: string, props?: TrackProps) => void {
  return useCallback((name: string, props?: TrackProps) => track(name, props ?? {}), []);
}
